import React, { Component } from "react";

import "./tools-summary-card.css";

class ToolsSummaryCard extends Component {
	renderMetaItem = (item, index) => {
		return (
			<React.Fragment key={index}>
				{index > 0 && <span className="tools-summary-card__meta-dot">·</span>}
				<span className="tools-summary-card__meta-item">
					{item.icon}
					{item.text}
				</span>
			</React.Fragment>
		);
	};

	render() {
		const { icon, tone = "neutral", title, value, valueSuffix, meta = [] } = this.props;

		const iconClass = "tools-summary-card__icon tools-summary-card__icon--" + tone;
		const valueClass = "tools-summary-card__value tools-summary-card__value--" + tone;

		return (
			<div className="tools-summary-card">
				<span className={iconClass}>{icon}</span>
				<div className="tools-summary-card__main">
					<div className="tools-summary-card__title">{title}</div>
					{value !== undefined && (
						<div className="tools-summary-card__value-row">
							<span className={valueClass}>{value}</span>
							{valueSuffix && <span className="tools-summary-card__value-suffix">{valueSuffix}</span>}
						</div>
					)}
					{meta.length > 0 && <div className="tools-summary-card__meta">{meta.map(this.renderMetaItem)}</div>}
				</div>
			</div>
		);
	}
}

export default ToolsSummaryCard;
